export const NEEDS_AT_LEAST = 2;

export const TAKES_AT_MOST = 4;
